/* In Focus: preload each new pair, then crossfade without shifting the layout. */
(() => {
  const instances = new Map();
  const init = () => document.querySelectorAll('[data-mc-rotate="hero"]').forEach(slot => {
    if (instances.has(slot)) return;
    let source;
    try { source = JSON.parse(slot.querySelector('[data-mc-rotation-pool]')?.textContent || '[]'); } catch (_) { return; }
    if (!Array.isArray(source)) return;
    const seen = new Set();
    const pool = source.filter(p => {
      if (!p?.id || !p.image || !p.url || !p.title || p.available === false) return false;
      try {
        const key = new URL(p.image, location.origin).pathname;
        if (seen.has(key)) return false;
        seen.add(key); return true;
      } catch (_) { return false; }
    });
    const images = [...slot.children].filter(node => node.tagName === 'IMG');
    if (!images.length || pool.length <= images.length) return;
    const region = slot.closest('.mc-hero') || slot;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const cleanups = [];
    let queue = [], timer = 0, finishTimer = 0, busy = false, destroyed = false;
    let visible = !window.IntersectionObserver, hovered = false, focused = false, stopped = false;
    const listen = (node, type, fn) => { node.addEventListener(type, fn); cleanups.push(() => node.removeEventListener(type, fn)); };
    const canRun = () => !destroyed && slot.isConnected && visible && !document.hidden && !motion.matches && !hovered && !focused && !stopped;
    const schedule = () => {
      clearTimeout(timer);
      if (canRun() && !busy) timer = setTimeout(advance, 3000);
    };
    const pick = () => {
      const current = new Set([slot.dataset.mcProductId, ...images.map(img => img.dataset.mcProductId)].filter(Boolean));
      const selected = [];
      while (selected.length < images.length) {
        if (!queue.length) {
          queue = pool.slice();
          for (let i = queue.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [queue[i], queue[j]] = [queue[j], queue[i]];
          }
        }
        let index = queue.findIndex(p => !current.has(p.id) && !selected.some(s => s.id === p.id));
        if (index < 0) index = queue.findIndex(p => !selected.some(s => s.id === p.id));
        if (index < 0) { queue = []; continue; }
        selected.push(queue.splice(index, 1)[0]);
      }
      return selected;
    };
    const preload = (product, original) => new Promise((resolve, reject) => {
      const img = new Image();
      const timeout = setTimeout(() => { img.onload = img.onerror = null; reject(new Error('Image timeout')); }, 15000);
      const settle = (ok) => { clearTimeout(timeout); img.onload = img.onerror = null; ok ? resolve(img) : reject(new Error('Image unavailable')); };
      img.onload = () => settle(true); img.onerror = () => settle(false);
      img.alt = product.title; img.width = product.width; img.height = product.height;
      img.className = original.className; img.dataset.mcProductId = product.id;
      img.sizes = original.sizes || '(min-width: 600px) 50vw, 100vw';
      const url = width => { const u = new URL(product.image, location.origin); u.searchParams.set('width', width); return u.href; };
      img.srcset = [480, 750, 1000, 1500].map(width => url(width) + ' ' + width + 'w').join(', ');
      img.src = url(1500);
    });
    async function advance() {
      timer = 0;
      if (!canRun() || busy) return;
      busy = true;
      const selected = pick();
      let incoming;
      try { incoming = await Promise.all(selected.map((p, index) => preload(p, images[index]))); }
      catch (_) { busy = false; schedule(); return; }
      if (!canRun()) { busy = false; schedule(); return; }
      const layer = document.createElement('div');
      layer.className = 'mc-focus-incoming'; layer.setAttribute('aria-hidden', 'true');
      incoming.forEach(img => layer.append(img)); slot.append(layer);
      // Establish the initial opacity before starting the crossfade.
      layer.getBoundingClientRect(); layer.classList.add('is-visible');
      finishTimer = setTimeout(() => {
        if (destroyed) return;
        incoming.forEach((img, index) => {
          images[index].replaceWith(img); images[index] = img;
        });
        layer.remove(); slot.dataset.mcProductId = selected[0].id;
        const caption = slot.querySelector('.mc-image-caption');
        if (caption) {
          caption.href = selected[0].url;
          const title = caption.querySelector('span > span');
          if (title) title.textContent = selected[0].title;
        }
        try {
          const history = JSON.parse(localStorage.getItem('mc-home-image-rotation-v2') || '{}');
          history.hero = {last:selected.map(p => p.id), remaining:queue.map(p => p.id)};
          localStorage.setItem('mc-home-image-rotation-v2', JSON.stringify(history));
        } catch (_) {}
        busy = false; schedule();
      }, 650);
    }
    listen(region, 'pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; schedule(); } });
    listen(region, 'pointerleave', () => { hovered = false; schedule(); });
    listen(region, 'focusin', () => { focused = true; schedule(); });
    listen(region, 'focusout', event => { if (!region.contains(event.relatedTarget)) { focused = false; schedule(); } });
    listen(region, 'keydown', event => { if (event.key === 'Escape') { stopped = true; schedule(); } });
    listen(document, 'visibilitychange', schedule);
    listen(motion, 'change', schedule);
    let observer;
    if (window.IntersectionObserver) {
      observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, {threshold:0.1});
      observer.observe(region);
    }
    instances.set(slot, {destroy:() => {
      destroyed = true; clearTimeout(timer); clearTimeout(finishTimer);
      observer?.disconnect(); cleanups.forEach(fn => fn());
      slot.querySelector('.mc-focus-incoming')?.remove();
    }});
    schedule();
  });
  document.addEventListener('mc:home-rotated', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => instances.forEach((instance, slot) => {
    if (event.target.contains(slot)) { instance.destroy(); instances.delete(slot); }
  }));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
